import React, { useState, useEffect } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { withRouter, useHistory } from 'react-router-dom';
import './Toolbar.css';

function logOut() {
    localStorage.removeItem('kokos_userdata');
    window.location.reload();
}

function ToolBar(props) {

    let history = useHistory();
    console.log("qwerty", props.user)

    const renderUserItems = () => {
        return (
            <Popover style={{ width: '15vw' }} id="popover-basic">
                <Popover.Title as="h3" style={{ marginTop: '0px' }}>
                    <div className="Toolbar-popover-schoolmain">
                        <img className="Toolbar-popover-schoolimg" src={require('../../images/graduation-hat.png')} />
                        <div className="Toolbar-popover-schoolname">{props.user? props.user.school_name : ''}</div>
                    </div>
                </Popover.Title>
                <Popover.Content>
                    <div className="Toolbar-popover-schoolmain">
                        <img className="Toolbar-popover-avatarimg" src={require('../../images/kokos_avatar.png')} />
                        <div className="Toolbar-popover-pro_name">{props.user ? props.user.username : ''}</div>
                    </div>
                    <div className="Toolbar-popover-schoolmain">
                        <img className="Toolbar-popover-logoutimg" src={require('../../images/power-button.png')} />
                        <div className="Toolbar-popover-logout" onClick={() => {logOut()}}>Sign Out</div>
                    </div>
                </Popover.Content>
            </Popover>
        );
    }

    return (
        <div className="Toolbar_main">
            <img className="Toolbar_admin" src={require('../../images/kokos.png')} />
            {(window.location.pathname === "/Schools" || window.location.pathname === "/AddUser" || window.location.pathname === "/") ?
                <div></div>
                :
                <div className="Toolbar_schooname">{props.user? props.user.school_name : ''}</div>}
            {(window.location.pathname === "/") ?
                <div></div> :
                <OverlayTrigger trigger="click" placement="bottom" overlay={renderUserItems()} rootClose>
                    <div className="Toolbar-avatar-main">
                        <img className="Toolbar_avatar" src={require('../../images/kokos_avatar.png')} />
                        <img className="Toolbar_avatar_down" src={require('../../images/down.png')} />
                    </div>
                </OverlayTrigger>}
        </div>
    );
}


export default (withRouter(ToolBar));